import { render } from "./CompleteTransfer.vue?vue&type=template&id=4214a804"
import script from "./CompleteTransfer.vue?vue&type=script&lang=js"
export * from "./CompleteTransfer.vue?vue&type=script&lang=js"
script.render = render

export default script